export enum CodeExtremesDecree {
  Normale = 'NORMALE',
  Riammissione = 'RIAMMISSIONE',
  Ritardo = 'RITARDO',
}
